import { render } from "./RiverAuth.vue?vue&type=template&id=36d50a44&scoped=true"
import script from "./RiverAuth.vue?vue&type=script&lang=js"
export * from "./RiverAuth.vue?vue&type=script&lang=js"

import "./RiverAuth.vue?vue&type=style&index=0&id=36d50a44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36d50a44"]])

export default __exports__